import { render } from "./MediaIconBtn.vue?vue&type=template&id=9d74088c&scoped=true"
import script from "./MediaIconBtn.vue?vue&type=script&lang=js"
export * from "./MediaIconBtn.vue?vue&type=script&lang=js"

import "./MediaIconBtn.vue?vue&type=style&index=0&id=9d74088c&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d74088c"]])

export default __exports__